"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResponseResolverAsText = exports.ResponseResolverAsTextStream = exports.ResponseResolverAsJson = exports.ResponseResolverAsBlob = exports.ResponseResolver = void 0;
const core_1 = require("../core");
const messages_1 = require("../xhr/messages");
const types_1 = require("../xhr/types");
class ResponseResolver {
    static getContent(response, resolver) {
        return __awaiter(this, void 0, void 0, function* () {
            const content = yield resolver.resolve(response.clone());
            if (typeof content !== 'string') {
                return content;
            }
            return new ResponseResolverAsText().resolve(response.clone());
        });
    }
    static resolve(response_1) {
        return __awaiter(this, arguments, void 0, function* (response, responseType = types_1.MediaType.JSON) {
            if (responseType === types_1.MediaType.BLOB) {
                return this.getContent(response, new ResponseResolverAsBlob());
            }
            if (responseType === types_1.MediaType.STREAMEVENT) {
                return this.getContent(response, new ResponseResolverAsTextStream());
            }
            return this.getContent(response, new ResponseResolverAsJson());
        });
    }
}
exports.ResponseResolver = ResponseResolver;
class ResponseResolverAsBlob {
    constructor() {
        this.xhrMessage = messages_1.XHRMessages.XHR_FETCH_NON_BLOB;
    }
    resolve(response) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                return yield response.blob();
            }
            catch (_) {
                core_1.Log.warn(this.xhrMessage);
                return this.xhrMessage;
            }
        });
    }
}
exports.ResponseResolverAsBlob = ResponseResolverAsBlob;
class ResponseResolverAsJson {
    constructor() {
        this.xhrMessage = messages_1.XHRMessages.XHR_FETCH_NON_JSON;
    }
    resolve(response) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                return yield response.json();
            }
            catch (_) {
                core_1.Log.warn(this.xhrMessage);
                return this.xhrMessage;
            }
        });
    }
}
exports.ResponseResolverAsJson = ResponseResolverAsJson;
class ResponseResolverAsTextStream {
    constructor() {
        this.xhrMessage = messages_1.XHRMessages.XHR_FETCH_NON_TEXT_STREAM;
    }
    resolve(response) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                if (!response.body) {
                    throw new Error();
                }
                return response.body;
            }
            catch (_) {
                core_1.Log.warn(this.xhrMessage);
                return this.xhrMessage;
            }
        });
    }
}
exports.ResponseResolverAsTextStream = ResponseResolverAsTextStream;
class ResponseResolverAsText {
    resolve(response) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield response.text();
        });
    }
}
exports.ResponseResolverAsText = ResponseResolverAsText;
//# sourceMappingURL=responseResolvers.js.map